var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIsa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2a1.001 1.001 0 000 2 1.001 1.001 0 000-2zm0 4C8.346 6 7 4.654 7 3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19.031h-3a1 1 0 01-.8-.4l-2.7-3.6h-5.434a1 1 0 01-1-1v-8.6a1 1 0 012 0v7.6H16a1 1 0 01.8.4l2.7 3.6H22a1 1 0 110 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.467 10.031h-4.4a1 1 0 110-2h4.4a1 1 0 110 2zM9.333 24.031C4.738 24.031 1 20.293 1 15.698a8.385 8.385 0 014.719-7.511 1 1 0 01.869 1.802A6.372 6.372 0 003 15.698a6.34 6.34 0 006.333 6.333 6.338 6.338 0 005.219-2.743 1 1 0 111.646 1.135 8.336 8.336 0 01-6.865 3.608z"
  }))));
}

export default SvgIconIsa;